<div class="agpr-viActiveQuestionSummary">
    <div class="agpr-viActiveQuestionSummary-header">
        <span class="agpr-viActiveQuestionSummary-label">
            {{ 'VisibilityIntelligence.querySetup.activeQuestionSummary.label' | localize }}
        </span>
        <span class="agpr-viActiveQuestionSummary-count">{{ questionsCount }}</span>
        <agpr-button
            [id]="id + '_toggle'"
            class="agpr-viActiveQuestionSummary-toggleButton"
            [style]="buttonTypes.icon"
            [icon]="isExpanded ? 'fa-solid fa-angle-up' : 'fa-solid fa-angle-down'"
            [tooltip]="isExpanded ? 'Core.collapse' : 'Core.expand'"
            tooltipPosition="left"
            [initiallyFocusable]="false"
            (click)="toggle()"
        ></agpr-button>
    </div>
    <agpr-message
        class="agpr-viActiveQuestionSummary-banner"
        [severity]="bannerSeverity"
        [bottomMargin]="false"
    >
        <p [innerHTML]="bannerMessage"></p>
    </agpr-message>
    <div
        class="agpr-viActiveQuestionSummary-content"
        [@cardState]="{value: isExpanded ? 'expanded' : 'collapsed'}"
    >
        <div class="agpr-viActiveQuestionSummary-detailList">
            <div class="agpr-viActiveQuestionSummary-detailItem">
                <span class="agpr-viActiveQuestionSummary-detailItem-label">
                    {{ 'VisibilityIntelligence.querySetup.activeQuestionSummary.totalActiveQuestions' | localize }}
                </span>
                <span class="agpr-viActiveQuestionSummary-detailItem-value">{{ totalActiveQuestions }}</span>
            </div>
            <div class="agpr-viActiveQuestionSummary-detailItem">
                <span class="agpr-viActiveQuestionSummary-detailItem-label">
                    {{ 'VisibilityIntelligence.querySetup.activeQuestionSummary.totalActiveQuestionsUsed' | localize }}
                </span>
                <span class="agpr-viActiveQuestionSummary-detailItem-value">{{ totalActiveQuestionsUsed }}</span>
            </div>
            <div class="agpr-viActiveQuestionSummary-detailItem">
                <span class="agpr-viActiveQuestionSummary-detailItem-label">
                    {{ 'VisibilityIntelligence.querySetup.activeQuestionSummary.remainingActiveQuestions' | localize }}
                </span>
                <span class="agpr-viActiveQuestionSummary-detailItem-value">{{ remainingActiveQuestions }}</span>
            </div>
        </div>
    </div>
</div>
